import getDateFormats from "../constants/dateFormats";

/**
 * For the dropdown
 * @param {number} calendarType Relative or the absolute types
 */
const dateFormatOptions = (calendarType, dateOrder) => {
  const formats = getDateFormats(calendarType, dateOrder);
  return Object.keys(formats).reduce((optArr, key) => {
    optArr.push({ label: formats[key], value: key });
    return optArr;
  }, []);
};

export { dateFormatOptions };
